"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const photos = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/matchday_fan_celebration.png",
  alt: "WT Birkalla fans celebrating a goal",
  caption: "The 12th Man"
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/matchday_flare_display.png",
  alt: "Gold flares lighting up the stands",
  caption: "Pitch Passion"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/matchday_winning_goal.png",
  alt: "Senior player scoring a decisive goal",
  caption: "Match Winner"
}, {
  id: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/matchday_stadium_lights.png",
  alt: "Jack Smith Park under the lights",
  caption: "Friday Night Lights"
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/matchday_team_huddle.png",
  alt: "WT Birkalla team huddle before kickoff",
  caption: "United Strength"
}, {
  id: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/matchday_junior_mascots.png",
  alt: "Junior players walking out with seniors",
  caption: "Future Stars"
}, {
  id: 7,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/matchday_clubroom_atmosphere.png",
  alt: "Fans enjoying drinks in the clubroom",
  caption: "Clubroom Vibes"
}, {
  id: 8,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/matchday_corner_kick.png",
  alt: "Action shot of a corner kick delivery",
  caption: "Precision Play"
}, {
  id: 9,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/matchday_trophy_lift.png",
  alt: "Captain lifting a trophy",
  caption: "Championship Glory"
}, {
  id: 10,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/matchday_goalkeeper_save.png",
  alt: "Goalkeeper making a diving save",
  caption: "The Wall"
}, {
  id: 11,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/matchday_sideline_coaching.png",
  alt: "Coaching staff directing the play",
  caption: "Tactical Edge"
}, {
  id: 12,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/matchday_sunset_pitch.png",
  alt: "Sunset over the football pitch",
  caption: "Golden Hour"
}];
export default function PhotoGallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section data-section-id="241184" id="match-day-experience" className="bg-background py-16 md:py-24">
      <div ref={ref} className={`mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="mb-10 text-center md:mb-16">
          <h2 className="font-default text-4xl font-extrabold uppercase tracking-tighter text-foreground sm:text-5xl lg:text-6xl">
            Match Day <span className="text-primary">Experience</span>
          </h2>
          <p className="font-default mt-4 text-lg text-muted-foreground max-w-2xl mx-auto">
            Feel the energy of Jack Smith Park. From the roar of the crowd to the final whistle, witness the passion of WT Birkalla.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 lg:gap-x-6 lg:gap-y-10">
          {photos.map((photo, i) => <div key={photo.id} data-index={i} className="group flex flex-col items-center">
              <div className="relative w-full overflow-hidden rounded-sm border border-border bg-card aspect-square shadow-lg">
                <div className="absolute inset-0 z-10 bg-gradient-to-t from-background/80 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                <img src={photo.src} alt={photo.alt} className="h-full w-full object-cover object-center transition-transform duration-500 ease-in-out group-hover:scale-110 grayscale group-hover:grayscale-0" loading="lazy" />
                <div className="absolute top-0 left-0 w-full h-0.5 bg-primary scale-x-0 transition-transform duration-300 group-hover:scale-x-100 origin-left z-20" />
              </div>
              <p className="font-mono mt-3 text-xs font-bold uppercase tracking-widest text-primary text-center">
                {photo.caption}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}